<template>
  <div id="embed" class="isEmbed">
    <FlashMessage />
    <FlashNotifications />
    <ToastNotifications />
    <transition name="pagefade">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
// do not use dynamic loading to make sure Flash message event bus normal
import FlashMessage from '@/components/modules/common/FlashMessage.vue';

export default {
  name: 'embed-layout',
  components: {
    FlashMessage,
    FlashNotifications: () => import('@motionelements/core/src/components/ui/notifications/BaseFlashNotifications.vue'),
    ToastNotifications: () => import('@motionelements/core/src/components/ui/notifications/BaseToastNotifications.vue'),
  },
  head: {
    base: {
      target: '_parent',
    },
  },
};
</script>

<style lang="scss">
.grecaptcha-badge {
  visibility: hidden;
}
</style>
